export default __webpack_public_path__ + "static/pic12-75003824c4b1779aea0b1c51de96597a.jpg";